import React from 'react';
import classnames from 'classnames';
import { injectIntl, defineMessages } from 'react-intl';
import removeIcon from './remove-icon.svg';
import editIcon from './edit-icon.svg';

const messages = defineMessages({
  editAttachment: {
    id: '',
    description: 'tooltip text in attachment modal, lets users edit attachment info',
    defaultMessage: 'Edit attachment',
  },
  deleteAttachment: {
    id: '',
    description: 'tooltip text in attachment modal, lets users delete attachment info',
    defaultMessage: 'Delete attachment',
  },
});

class Attachment extends React.Component {

    deleteAttachment = () => {
      this.props.deleteAttachment(this.props.attachment.id);
    };

    editAttachment = () => {
      this.props.editAttachment(this.props.attachment);
    };

    render() {
      const { attachment, readOnly } = this.props;

      const className = classnames({
        'attachment-button__attachment-name': true,
        'attachment-button__attachment-name--required': attachment.required,
      });


      return (
        <li className={classnames({
          'attachment-button__attached': true,
          'attachment-button__attached--read-only': readOnly,
        })}
        >
          <span className={className}>
            {attachment.name}
          </span>

          <img
            className="attachment-button__delete-icon"
            src={removeIcon}
            onClick={this.deleteAttachment}
            title={this.props.intl.formatMessage(messages.deleteAttachment)}
            alt={this.props.intl.formatMessage(messages.deleteAttachment)} />
          <img
            className="attachment-button__edit-icon"
            src={editIcon}
            onClick={this.editAttachment}
            title={this.props.intl.formatMessage(messages.editAttachment)}
            alt={this.props.intl.formatMessage(messages.editAttachment)} />
        </li>
      );
    }
}

export default injectIntl(Attachment);
